<template>
  <iframe
    :src="url"
    frameborder="0"
    width="100%"
    height="300"
    autoplay
    id="iframe"
    allowfullscreen="true"
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
  >
    暂无视频
  </iframe>
</template>

<script>
export default {
  props: {
    url: {
      default: "",
      type: String
    }
  }
};
</script>

<style></style>
